/**
 * Created by adalto on 8/5/14.
 */


Greenmile.UserPreferences = Greenmile.UserPreferences || {};
Greenmile.UserPreferences.Default = {

    getDefaultPreferences: function () {
        return {
            supplierMap: {
                "supplier_map": "greenmileMap"
            },
            HOS: {
                on_duty: false,
                off_duty: false,
                driving: false,
                break_hos: false,
                wait_hos: false,
                lunch: false
            },
            layerMap: {
                routes: true,
                actual_route: true,
                planned_route: true,
                baseline_planned_route: false,
                event_route: false,
                event_equipment: false,
                radius_route: false,
                pending_order: false,
                stops: true
            },
            preferenceShowGrid: true,
            telematic: ['speed'],
            mapmain: {
                center: '',
                zoom: ''
            },
            TrackEquipment: {
                "showTabs": true
            },
            infoMarkerTruck: {},
            showGridRouteDetail: {
                "show_grid": true
            },
            isUpdated: false,
            whatsNew: true,
            stoppedTime: 60,
            nearGeofence: true
        };
    }
};
